import axios from "axios";

const shiftService = {
  getShifts: () =>
    axios.get(`/Roster/GetSheduledetails`),
  postShift: (shiftData) =>
    axios.post(`/Roster/PostSchedule`, [shiftData]),
};

export default shiftService;